<!----------------------------   Program description   ----------------------------
- Vue Name ID   :
- Vue Name  :
- Author      :
- Create Date :
- Change History
======================================================================================
 수정일           / 이름 / 사유
======================================================================================
 YYYY.MM.DD  / XYZ / 신규
--------------------------------------------------------------------------------------->


<!-------------------------------------------------------------------------------------
- 1. template
--------------------------------------------------------------------------------------->
<template>
<div id="layer-wrap" v-if="initAt">
  <div>
    <table class="print_page"  >
      <colgroup>
        <col style="width:5%"/>
        <col style="width:20%"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody style="border : 1px solid black;">
      <tr>
        <td colspan="3"  class="last">
          <h2 style="padding: 10px; font-weight: bolder; font-size: 25px;">어린이집 안심 등 하원 ∙ 알림서비스 ‘걸음마 아이오감‘ 사용계약</h2>
        </td>
      </tr>
      <tr>
        <td rowspan="3">계<br>약<br>자</td>
        <td>발주자<br>(어린이집)</td>
        <td style="text-align: left;" class="last">
          어린이집명 : {{srvcInfo.fcltNm}} <br>
          사업자등록번호 : {{srvcInfo.bizrno}} <br>
          주소 : {{srvcInfo.adres}} <br>
          대표자 :

        </td>
      </tr>
      <tr>
        <td>서비스수행자<br>(위치정보사업)</td>
        <td style="text-align: left;"  class="last">
          업체명 : 에이티엔 <br>
          사업자등록번호 : 126-86-03002  <br>
          주소 : 경기도 이천시 마장면 덕평로 771-10 <br>
          대표자 : 안동석
        </td>
      </tr>
      <tr>
        <td>서비스수행자<br>(위치기반서비스)</td>
        <td style="text-align: left;"  class="last">
          업체명 : 온앤온정보시스템 <br>
          사업자등록번호 :  120-81-84415 <br>
          주소 : 서울시 강동구 천호대로 1095 현대코아아파트상가 301호 <br>
          대표자 : 김종찬
        </td>
      </tr>
      <tr>
        <td rowspan="6">계<br>약<br>내<br>용</td>
        <td>목적</td>
        <td style="text-align: left;"  class="last">
          본계약은 ㈜에이티엔 사업자가 발주자에게 어린이 안심 등 하원 ∙ 알림서비스
          ‘걸음마 아이오감‘ 를 제공하는데 그 목적이 있다 (서비스 기본 계약서 참조)
        </td>
      </tr>
      <tr>
        <td>계약기간</td>
        <td style="text-align: left;"  class="last">
          계약일로부터 10년간 <br>
          무상 A/S 3년, 유상A/S 7년(유상A/S: 어댑터 등 소모품비 실비청구)
        </td>
      </tr>
      <tr>
        <td>전자출결장비<br>설치비</td>
        <td style="text-align: left;"  class="last">
          총액 {{contractInfo.totPrice}} <br>
          -리더기 : {{contractInfo.detectorPrice}} <br>
          -태그 : {{contractInfo.tagPrice}}
        </td>
      </tr>
      <tr>
        <td>서비스 이용료</td>
        <td style="text-align: left;"  class="last">
          매월<span style="margin-left:100px;">원</span><br>
          <span style="font-size: 15px;">(기본 20인이하 11,000원, 21~40인 22,000원, 41~80인 33,000, 81인 이상 44,000원) <br>
            + (추가 1대당 6,600원 합산)</span>
        </td>
      </tr>
      <tr>
        <td>세부내역</td>
        <td style="text-align: left;"  class="last">
          서비스 기본계약서의 제 4조 참조
        </td>
      </tr>
      <tr>
        <td>서비스 이용료<br>수납방법</td>
        <td style="text-align: left;"  class="last">
          서비스 기본계약서의 제 5조 참조
        </td>
      </tr>
      <tr>
        <td colspan="3" style=" font-size: 17px; border-bottom: none; padding-top:30px; padding-bottom: 130px;"  class="last">
          “발주자”와 “서비스수행자”는 상호 대등한 입장에서 위 계약을 체결하고<br> 신의에 따라 성실히
          계약상의 의무를 이행할 것을 확약하며<br>
          이 계약의 증거로서 계약서를 작성하여 당사자가 기명 날인 후 각각 1통씩 보관한다.
        </td>
      </tr>
      <tr>
        <td colspan="3" style="border-top: none;border-bottom: none; padding-bottom: 30px;"  class="last">
          {{dayInfo.yy}}년  <span style="margin-left: 30px;margin-right: 35px;">월</span>  일
        </td>
      </tr>
      <tr style="margin-bottom: 30px;">
        <td colspan="3" style="border-top: none;border-bottom: none; padding-bottom: 30px;"  class="last">
          <span style="margin-left: 120px;">어린이집 대표자</span>
          <span style="margin-left: 110px;">(인)</span>
        </td>
      </tr>
      <tr>
        <td colspan="3" style="border-top: none;border-bottom: none; padding-bottom: 30px;"  class="last">
          <span style="margin-left:55px;">(주)에이티엔 대표자</span>
          <span style="padding-left: 45px">안동석</span>
          <img class="apply-print-padding"
               style="position: absolute; margin-left: 15px;margin-top: -12px;width: 40px;"
               src="../../../../assets/i5gam/images/atn-stamp.png">
        </td>
      </tr>
      <tr>
        <td colspan="3"  style="border-bottom: 1px solid black; border-top: none; padding-bottom: 60px;"  class="last">
          <span style="padding-right: 20px;">(주)온앤온정보시스템 대표자</span>
          <span style="padding-left: 25px;">김종찬</span>
          <img class="apply-print-padding"
               style="position: absolute; margin-left: 10px;margin-top: -12px;width: 40px;"
               src="../../../../assets/i5gam/images/onandon-stamp.png">
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div id="contract1">
    <div class="print_page">
      <h1 style="font-size: 35px; text-align: center; margin-bottom: 15px;">서비스 기본 계약서</h1>
      <div class="ct-div">
        <p>제 1 조(계약 당사자)</p>
        <span>㈜에이티엔과 ㈜온앤온정보시스템 (이하 “사업자”)와 발주자(이하 “어린이집”)은 상호 신의와 성실을 바탕으로 다음과
              같이 어린이 스마트안전지킴이 (이하 “서비스”) 상용서비스 계약을 체결한다.</span>
      </div>
      <div class="ct-div">
        <p>제 2 조(계약의 목적)</p>
        <span>본 계약은 “사업자”의 “서비스”를 이용하는 “어린이집”에게 서비스를 제공하는 것과 관련하여 “사업자”와 “어린이집”의 권리와 의무 등 필요한
          제반사항을 규정하고 본 계약서에 기재한 내용대로 신의 성실의 원칙에 입각하여 이를 충실히 이행하는데 목적이 있다.</span>
      </div>
      <div class="ct-div">
        <span>제 3 조(용어 정의)</span>
        <ol>
          <li>1. 리더기란 근거리 무선통신 기술을 이용하여 태그의 정보를 확인하는 단말기를 말한다.</li>
          <li>2. 태그란 어린이집에 등록된 어린이의 일부 정보를 입력하고 저장하는 장치를 말한다.</li>
          <li>3. 전자출결 장비란 리더기와 태그를 함께 지칭할 경우를 말한다.</li>
        </ol>
      </div>
      <div class="ct-div">
        <span>제 4 조(서비스 내역)</span>
        <p style="padding-bottom: 10px;">“사업자”는 “어린이집”에게 유, 무선 인터넷을 통하여 아래와 같이 서비스를 제공한다.</p>
        <table>
          <colgroup>
            <col style="width:40%"/>
            <col style="width:auto;"/>
          </colgroup>
          <tbody>
            <tr style="background-color:#d8eeff;" >
              <td>구분</td>
              <td class="last">서비스 내역</td>
            </tr>
            <tr>
              <td>사용자용</td>
              <td class="last">등하원 알림 알림장 투약의뢰 귀가동의서 식단표 공지사항 고객지원</td>
            </tr>
            <tr>
              <td style="border-bottom: solid black 1px;">관리자용</td>
              <td class="last" style="border-bottom: solid black 1px;">등하원 알림, 전자출결, 예상 연장보육료 확인, 알림장, 투약의뢰, <br> 귀가동의서, 식단표, 공지사항, 고객지원</td>
            </tr>
          </tbody>
        </table>
        <div class="ct-div">
          <p>제 5 조(서비스 이용료의 정산)</p>
          <ol>
           <li>1. “리더기”, “태그”, 설치비는 설치시 50% 이상, 설치 후 1달 이내 차액을 CMS, 카드자동이체, 은행자동이체 중
            “사업자”가 지정한 방법으로 납부한다.</li>
           <li>2. “어린이집”은 CMS, 카드자동이체, 은행자동이체 등의 방법으로 지정된 납부일에 매월에 이용료를 납부한다.</li>
          </ol>
        </div>
        <div class="ct-div">
          <p>제 6 조(전자출결장비(태그, 리더기) 설치 및 하차 처리)</p>
          <ol>
            <li>1. 전자출결 장비는 계약일로부터 3일 이내 또는 상호 협의한 날짜에 설치되어야 한다.</li>
            <li>2. 전자출결 장비의 하자 처리 기간은 본 사업의 계약기간내로 한다.</li>
            <li>3. “태그”의 인식 불량 및 오인식일 경우 무상으로 수리 및 교체하여야 한다.<br>
              단 분실 , 또는 파손 시 필요수량 만큼 추가 구입하여 “어린이집”의 청구에 따라 지급하여야 한다.</li>
            <li>4. “리더기”의 하자가 발생하는 경우 “사업자”는 “어린이집”의 요청에 따라 즉시 “리더기”를 교체 또는 무상수리
              하여야 한다. 단, 계약기간 4년차부터는 어댑터 등 소모품에 대한 비용은 “사업자”의 청구에 따라 지급하여야
              한다.</li>
            <li>단, “어린이집”의 고의 및 과실로 인하여 하자가 발생할 경우 “어린이집”은 ”리더기”의 수리 및 교체에 따른 비용
              을 “사업자”의 청구에 따라 지급하여야 한다.</li>
          </ol>
        </div>
        <div class="ct-div">
          <p>제 7 조(교육 및 민원 대응)</p>
          <ol>
            <li>1. 서비스수행자는 발주자의 원활한 서비스 이용을 위해 최초 설치 시 발주자 요청 시 사용법에 대한 교육을 실시
            하여야 한다.</li>
            <li>2. 서비스 이용 중 불편사항 및 장애 등 민원 대응을 위해 어린이집 운영시간(09:00~19:30) 전담 콜센터
            (09:00~18:00)를 운영해야 하며, 그 외 시간은 ARS/홈페이지 등을 통해 별도 민원 응대를 하여야 한다.</li>
          </ol>
        </div>
        <div class="ct-div">
          <p>제 8 조(개인정보보호의무)</p>
          <ol>
            <li>1. 본 계약에서 “개인정보”라 함은 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」의 제 2조 제 1항 제6호,
               「개인정보보호법」 제2조 제1호 및 신용정보의 이용 및 보호에 관한 법률 제2조 제2호에서 정의하고 있는 정보로서
              각 당사자가 본 계약과 관련하여 구두, 문서, 디지털파일 등 그 형식과 방법을 불문하고 상대방으로부터 제공받은
              “어린이집” 회원의 정보를 말한다.</li>
          </ol>
        </div>
      </div>
    </div>

    <div class="print_page" id="contract2">
      <div class="ct-div">
        <ol>
          <li>2. 계약당사자는 “어린이집” 회원으로부터 정보를 수집할 시에 회원에 대한 본인확인을 수행하고, 회원의 정보를
            상대방에게 제공한다는 사실을 회원에게 고지하여 이에 대한 동의를 획득해야 한다. 또한 개인정보를 본 계약상
            목적 이외의 다른 용도로 사용할 수 없으며, 상대방의 사전 서명 승인없이는 어떤 경우에도 개인정보를 복사,
            복제, 가공하거나 제3자에게 제공, 판매, 발표할 수 없다.</li>
          <li>3. 어느 일방 당사자가 본 조항의 의무를 위반하고, 이로 인하여 그 상대방 또는 기타 제3자에게 손해가 발생할 경
            우 그에 대한 모든 책임은 조항 의무를 위반한 당사자가 부담하고 이와 관련하여 관계기관의 제재 또는 제 3자
            와의 분쟁 등이 발생할 경우 자기의 비용으로 상대방을 면책시켜야 한다. 또한 이와 관련하여 상대방에게 손해
            가 발생하거나 상대방이 지출한 비용이 있을 경우 본 조의 규정을 위반한 당사자는 이를 배상하여야 한다.</li>
        </ol>
      </div>
      <div class="ct-div">
        <p>제 9 조(양도 등 금지)</p>
        <p>
          계약당사자는 상호 사전 동의를 받지 아니하고는 본 협약에 기초하여 발생하는 어떠한 권리도 제 3자에게 양도하거나
          담보의 목적으로 제공하여서는 아니된다.
        </p>
      </div>
      <div class="ct-div">
        <p>제 10 조(계약의 해지)
        <p>
          계약당사자는 본 계약상의 의무를 위반한 때 혹은 다음 각 항에 해당할 때에는 본 계약을 해지할 수 있다. 단, 해지
          의사표시는 사전고지(2개월전)하여야 하며, 서비스 수행자의 귀책 사유인 경우 발주자의 업무 중단이 발생하지 않도록
          타 업체로 이관 등 최대한 협조하여야 한다.
        </p>
        <ol>
          <li>가. 본 계약을 위반하거나 중대한 하자가 발생한 때.</li>
          <li>나. 계약당사자 일방이 압류, 가압류, 가처분 등의 강제집행을 받아서 정상적인 영업 활동을 할 수 없게 된 경우</li>
          <li>다. 계약당사자가 부도, 폐업, 파산, 회생절차개시 등의 신청으로 정상적인 영업활동을 할 수 없게 된 경우</li>
          <li>라. 계약당사자가 귀책사유로 인해 영업상의 중대한 손해 또는 회원관리에 심각한 사태를 초래한 경우</li>
          <li>마. 기타 본 계약의 정상적인 이행이 곤란할 경우</li>
        </ol>
      </div>
      <div class="ct-div">
        <p>제 11 조(손해 배상)</p>
        <ol>
          <li>가. “사업자”의 귀책으로 전자출결 서비스 장애발생 등 사유로 “발주자” 손해 발생 시 장애기간과 피해금액을 고려
            하여 “발주자”에게 손해를 배상하여야 한다.</li>
          <li>나. “발주자”의 계약 설치비 및 이용료 등 미납으로 인해 “사업자”의 손해 발생 시 “발주자”는 “사업자”에게 손해
            를 배상하여야 한다.</li>
          <li>다. 기타 계약당사자간 계약 미이행으로 인해 상대방에 손해 발생 시 관련 법적 범위에서 상대방에게 손해를 배상
            하여야 한다.</li>
        </ol>
      </div>
      <div class="ct-div">
        <p>제 12 조(비밀 유지)</p>
        <ol>
          <li>가. “사업자”는 본 사업의 이행과 관하여 “발주자”로부터 얻은 사실을 본 사업이행 중 또는 계약 종료 후에도 제 3
            자에게 누설해서는 아니 된다.</li>
          <li>나. “사업자”는 본 사업의 수행 관련자에 대하여는 “가”항 의무를 알려 비밀을 유지하도록 하여야한다.</li>
          <li>다. 본조의 위반으로 “발주자”에게 손해를 발생하게 한 경우에는 이를 보상하여야 한다.</li>
        </ol>
      </div>
      <div class="ct-div">
        <p>제 13 조(보칙)</p>
        <ol>
          <li>가. 계약당사자는 상호 문서합의 후 “어린이집“의 승인을 득한 후 이 계약을 변경할 수 있다.</li>
          <li>나. 본 계약에 정하지 않은 사항 및 이의가 발생한 사항에 대해서는 상호협의 후 결정하며 협의가 되지 않을 경우
            일반 관례에 따른다.</li>
          <li>다. 본 계약은 계약일로부터 효력이 발생한다.</li>
          <li>라. 계약 만료일 1개월 전까지 당사자 일방으로부터 반대의 의사표시가 없을 경우 본 계약은 동일한 조건으로 1년
            간 자동 연장되는 것으로 한다.</li>
          <li>마. 본 계약 사실을 증명하기 위하여 계약서 2부를 작성하고 당사자가 서명 날인 후 각각 1부로 보관한다. 끝.</li>
        </ol>
      </div>
    </div>
    <div class="print_page">
      <div class="ct-div">
        <p style="margin-bottom: 5px;">[서식②] 표준 개인정보처리 위탁 계약서</p>
        <p style="border: 1px solid black; padding: 5px;">본 표준 개인정보처리위탁 계약서는 「개인정보 보호법」 제 26조 제 1항에 따라 위탁계약에
          있어 개인정보 처리에 관하여 문서로 정하여야 하는 최소한의 사항을 표준적으로 제시한
          것으로서 위탁계약이나, 위탁업무의 내용 등에 따라 세부적인 내용은 달라질 수 있습니다.
          개인정보 처리 업무를 위탁하거나 위탁업무에 개인정보 처리가 포함된 경우에는 본 표준
          개인정보처리위탁 계약서의 내용을 위탁계약서에 첨부하거나 반영하여 사용하실 수 있습니다.
        </p>
      </div>
      <div class="ct-div">
        <p style="text-decoration: underline;font-weight: bolder; font-size: 28px; text-align: center;">표준 개인정보처리 위탁 계약서</p>
      </div>
      <div class="ct-div">
        <p>{{srvcInfo.fcltNm}}(이하 “갑”이라 한다)과 ㈜에이티엔(이하 “을”이라 한다)는 “갑”의 개인정보
          처리업무를 “을”에게 위탁함에 있어 다음과 같은 내용으로 본 업무위탁계약을 체결한다. </p>
      </div>
      <div class="ct-div">
        <span class="ct-span">제1조 (목적)</span>이 계약은은 “갑”이 개인정보처리업무를 “을”에게 위탁하고, “을”은 이를
        승낙하여 “을”의 책임아래 성실하게 업무를 완성하도록 하는데 필요한 사항을 정함을 목적으로 한다.
      </div>
      <div class="ct-div">
        <span class="ct-span">제2조 (용어의 정의)</span>본 계약에서 별도로 정의되지 아니한 용어는 「개인정보 보호법」,
        같은 법 시행령 및 시행규칙, 「개인정보의 안전성 확보조치 기준」(행정안전부 고시 제 2017-1호) 및「표준 개인정보 보호지침」(행정안전부 고시 제2019-81호)에서 정의된
        바에 따른다.
      </div>
      <div class="ct-div">
        <span class="ct-span">제3조 (위탁업무의 목적 및 범위)</span>“을”은 계약이 정하는 바에 따라 어린이집 전자출결
        시스템 운영 관리 목적으로 다음과 같은 개인정보 처리 업무를 수행한다.1)
        <ol>
          <li>1. 회원가입 및 운영</li>
          <li>2. 아동의 등하원 시 위치정보 수집을 통한 위치기반 아동 출결정보 처리</li>
        </ol>
      </div>
      <div class="ct-div">
        <span class="ct-span">제4조 (위탁업무 기간) 이 계약서에 의한 개인정보 처리업무의 기간은 다음과 같다.</span>
        <p>계약 기간 : 2020년 3월 1일 ~ 해지 시</p>
      </div>
      <div class="ct-div">
        <span class="ct-span">제5조 (재위탁 제한)</span>
        ① “을”은 “갑”의 사전 승낙을 얻은 경우를 제외하고 “갑”과의 계약상의
        권리와 의무의 전부 또는 일부를 제 3자에게 양도하거나 재위탁할 수 없다.<br>
        ② “을”이 다른 제 3의 회사와 수탁계약을 할 경우에는 “을”은 해당 사실을 계약 체결
        7일 이전에 ”갑”에게 통보하고 협의하여야 한다.
      </div>
      <div class="ct-div">
        <span class="ct-span">제6조 (개인정보의 안전성 확보조치)</span> “을”은 「개인정보 보호법」 제23조 제2항 및 제24조 제3항 및 제 29조,
        같은 법 시행령 제21조 및 제30조, 「개인정보의 안전성 확보조치 기준」(행정안전부 고시 제2019-81호)에 따라 개인정보의 안전성 확보에 필요한 기술적,
        관리적 조치를 취하여야 한다.
      </div>
      <div class="ct-div">
        <span class="ct-span">제7조 (개인정보의 처리제한)</span>
        ① “을”은 계약기간은 물론 계약 종료 후에도 위탁업무
        수행 목적 범위를 넘어 개인정보를 이용하거나 이를 제 3자에게 제공 또는 누설하여서는 안 된다.<br>
        ② “을”은 계약이 해지되거나 또는 계약기간이 만료된 경우 위탁업무와 관련하여 보
        유하고 있는 개인정보를 「개인정보 보호법 시행령」 제16조 및 「개인정보의 안전성
        확보조치 기준」(행정안전부 고시 제2019-81호)에 따라 즉시 파기하거나 “갑”에게 반
        납하여야 한다.<br>
        ③ 제2항에 따라 “을”이 개인정보를 파기한 경우 지체없이 “갑”에게 그 결과를 통보하여야 한다.
      </div>
      <div class="ct-div">
        <span class="ct-span">제8조 (수탁자에 대한 관리·감독 등)</span>
        ① “갑”은 “을”에 대하여 다음 각 호의 사항을 감독할 수 있으며, “을”은 특별한 사유가 없는 한 이에 응하여야 한다.
        <ol>
          <li>1. 개인정보의 처리 현황</li>
          <li>2. 개인정보의 접근 또는 접속기록</li>
        </ol>
      </div>
      <div style="border-top: 1px black solid; width:760px;  padding-top:5px;">
        1)각호의 업무 예시 : 고객만족도 조사 업무, 회원가입 및 운영 업무, 사은품 배송을 위한 이름, 주소, 연락처 처리 등
      </div>
    </div>

    <div class="print_page">
      <div class="ct-div">
        <ol>
          <li>3. 개인정보 접근 또는 접속 대상자</li>
          <li>4. 목적외 이용.제공 및 재위탁 금지 준수여부</li>
          <li>5. 암호화 등 안전성 확보조치 이행여부</li>
          <li>6. 그 밖에 개인정보의 보호를 위하여 필요한 사항</li>
        </ol>
        ② “을”은 제1항 각 호의 사항에 대한 실태를 1년에 1회 점검하여 “갑”에게 보고한다.
        “갑”은 점검결과에 시정을 요구할 수 있으며, “을”은 특별한 사유가 없는 한 이행하여야 한다.<br>
        ③ “을”은 처리위탁으로 인하여 정보주체의 개인정보가 분실·도난·유출·변조 또는 훼손
        되지 아니하도록 1년에 2회 교육을 실시하고 그 결과를 “갑”에게 보고한다.2)<br>
        ④ 제1항에 따른 교육의 시기와 방법 등에 대해서는 “갑”은 “을”과 협의하여 시행한다.
      </div>
      <div class="ct-div">
        <span class="ct-span">제9조 (정보주체 권리보장)</span>
        ① “을”은 정보주체의 개인정보 열람, 정정·삭제, 처리 정지 요청
        등에 대응하기 위한 연락처 등 민원 창구를 마련해야 한다.
      </div>
      <div class="ct-div">
        <span class="ct-span">제10조 (개인정보의 파기)</span>
        ① “을”은 제4조의 위탁업무기간이 종료되면 특별한 사유가 없는
        한 지체 없이 개인정보를 파기하고 이를 “갑”에게 확인받아야 한다.
      </div>
      <div class="ct-div">
        <span class="ct-span">제11조 (손해배상)</span>
        ① “을” 또는 “을”의 임직원 기타 “을”의 수탁자가 이 계약에 의하여
        위탁 또는 재위탁 받은 업무를 수행함에 있어 이 계약에 따른 의무를 위반하거나
        “을” 또는 “을”의 임직원 기타 “을”의 수탁자의 귀책사유로 인하여 이 계약이 해지
        되어 “갑” 또는 개인정보주체 기타 제3자에게 손해가 발생한 경우 “을”은 그 손해를
        배상하여야 한다.<br>
        ② 제1항과 관련하여 개인정보주체 기타 제3자에게 발생한 손해에 대하여 “갑”이 전부
        또는 일부를 배상한 때에는 “갑”은 이를 “을”에게 구상할 수 있다.
      </div>
      <div style="padding-bottom: 200px;">
        <p>본 계약의 내용을 증명하기 위하여 계약서 2부를 작성하고, “갑”과 “을”이 서명 또는
          날인한 후 각 1부씩 보관한다.</p>
      </div>
      <div style="text-align: right; margin-bottom: 30px;">
        <span style="font-size: 20px;">{{dayInfo.yy}}</span>.
        <span style="margin-left: 30px; margin-right: 30px;">.</span>.
      </div>
      <div>
        <table id="tb">
          <colgroup>
            <col width="60%">
            <col width="auto;">
          </colgroup>
          <tr>
            <td style="text-align:left; border-left:none; border-top: none;">
              <p>갑 : {{srvcInfo.fcltNm}} </p>
              <p style="margin-top:12px; margin-bottom: 12px;">주소 : {{srvcInfo.adres}}</p>
              <span>성 명 : </span><span style="margin-left: 100px;">(인)</span>
            </td>
            <td style="text-align:left; border-top: none; border-left: none;">
              <p>을 : ㈜에이티엔</p>
              <p style="margin-top:12px; margin-bottom: 12px;">주소 : 경기도 이천시 마장면 덕평로 771-10</p>
              <span>대 표 자 : 안 동석
              <img class="apply-print-padding"
                   style="position: absolute; margin-left: 15px;margin-top: -12px;width: 40px;"
                   src="../../../../assets/i5gam/images/atn-stamp.png">
              </span>
            </td>
          </tr>
        </table>
      </div>
      <div style="border-top: 1px black solid; width:760px; margin-top:200px; padding-top:5px;">
        2)「개인정보의 안전성 확보조치 기준」(행정안전부 고시 제2019-81호) 및 「개인정보 보호법」제26조에 따라
        개인정보처리자 및 취급자는 개인정보보호에 관한 교육을 의무적으로 시행하여야 한다.
      </div>
    </div>
  </div>
</div>

</template>
<!-------------------------------------------------------------------------------------
- 2. Script
--------------------------------------------------------------------------------------->
<script>
/*======================================================================================*
 * 2.1. Import
 *======================================================================================*/

import {jsPDF} from "jspdf";
import html2canvas from "html2canvas";

export default {
  /*======================================================================================*
   * 2.2. 뷰 컴포넌트 명칭
   *======================================================================================*/
  name: "viewContractPopup",
  props: ['param'],
  /*======================================================================================*
   * 2.3. 지역 변수
   *======================================================================================*/
  data :function (){
    return{
      initAt: false,
      payInfo: null,
      srvcInfo: this.param.srvcInfo,
      orderInfo : this.param.orderInfo,
      priceInfo : this.param.priceInfo,
      contractInfo: {
        detectorPrice:'',
        tagPrice:'',
        totPrice:''
      },
      mode: 'download',
      printPadding: {
        top: 80,
        right: 70,
        bottom: 80,
        left: 70
      },
      timer : null
    }
  },
  /*======================================================================================*
   * 2.3. 함수 (일반 함수, 사용자 정의 함수, 이벤트 함수)
   *======================================================================================*/
  computed: {
    dayInfo: function(){
      return this.$store.getters.getDayInfo;
    },
    mberInfo : function () {
      return this.$store.getters.getMberInfo;
    }
  },
  methods: {
    init: function () {
      this.initAt = true;

      this.searchContractList();
    },
    searchContractList : function () {
      const priceInfo = this.priceInfo;

      let detectorMemo = '';
      if(priceInfo.detectorCnt > 0){
        const calCnt = priceInfo.detectorCalCnt;

        if(calCnt == 0) detectorMemo = '(';
        else detectorMemo = '(' + calCnt + '대X30만원';
        if(calCnt > 0&&priceInfo.discountCnt > 0) detectorMemo += ', ';
        if(priceInfo.discountCnt > 0) detectorMemo += '추가 ' + priceInfo.discountCnt + '대X22만원';
        detectorMemo += ')';
      }

      let tagMemo = '';
      if(priceInfo.tagCnt > 0){
        tagMemo = '(' + priceInfo.tagCnt + '개X개당5천원)';
      }
      this.contractInfo.detectorPrice=this.$onbiLib.addComma(priceInfo.detectorCalTotPrice) + '원'+detectorMemo;
      this.contractInfo.tagPrice=this.$onbiLib.addComma(priceInfo.tagTotPrice) + '원' + tagMemo;
      this.contractInfo.totPrice=this.$onbiLib.addComma(priceInfo.totPrice) + '원';


      this.$store.commit('setPageMaskShowAt',true);
      this.$nextTick(function () {
        this.pdfDownload();
      });
    },
    pdfDownload : function (){
      this.timer = setInterval(function(){
        this.drawCanvasToPdf();
        clearInterval(this.timer);
      }.bind(this), 3000);
    },
    drawCanvasToPdf: function(){
      this.pageList = new Array();
      let index = 0;
      let page = document.getElementsByClassName('print_page')

      for(const pageElement of page){
        pageElement.style.padding
            = this.printPadding.top + 'px '
            + this.printPadding.right + 'px '
            + this.printPadding.left + 'px ';
        this.pageList.push({setAt:false,dataURL : null,width:null,height:null})

        this.drawCanvas(pageElement,index);
        index++;
      }

      this.drawInterVal = setInterval(function(){
        let cnt = 0;
        this.pageList.forEach(function(info){
          if(info.setAt) cnt += 1;
        })
        if(this.pageList.length == cnt&&!this.createPdfAt){
          this.createPdfAt = true;
          const doc = new jsPDF({
            'orientation': 'p',
            'unit': 'mm',
            'format': 'a4',
            'compressPdf': true
          });

          const imgWidth   = 210;

          this.pageList.forEach(function(info,index){
            let imgHeight = (info.height * imgWidth / info.width);
            if(index > 0){ doc.addPage(); }
            doc.addImage(
                info.dataURL,
                'PNG',
                0,
                0,
                imgWidth ,
                imgHeight,
                'image' + index,
                'SLOW');
          })

          clearInterval(this.drawInterVal);
          this.$store.commit('setPageMaskShowAt',false);
          this.createPdfAt = false;

          if(this.mode == 'download'){
            let fileNm = '계약서_'+this.dayInfo.ymd;
            if(this.downloadFileNm != null){
              fileNm = this.downloadFileNm;
            }
            doc.save(fileNm+'.pdf');
          }

          this.finishPdf();
        }
      }.bind(this), 1000);
    },
    drawCanvas: function(pageElement,pageIndex){
      const dpi = 300;
      const scale = 2;

      html2canvas(
          pageElement,
          {
            dpi: dpi,
            scale: scale,
            scrollX : 0,
            scrollY : 0
          }
      ).then(function(canvas){
        let pageInfo = this.pageList[pageIndex];
        pageInfo.dataURL = canvas.toDataURL('image/png');
        pageInfo.width   = canvas.width;
        pageInfo.height  = canvas.height;
        pageInfo.setAt   = true;
      }.bind(this));
    },
    finishPdf: function(){
      this.$store.commit('closePopup');
    },
  },
  /*======================================================================================*
   * 2.4. Vue Life Cycle
   *======================================================================================*/
  mounted : function (){
    this.init();
  },


}
</script>

<style scoped>
.last{
  border-right: 1px solid black;
}


tr>td{
  text-align:center;
  line-height: 20px;
  border-top : 1px solid black;
  border-left : 1px solid black;
  padding: 5px;
  border-collapse : collapse;
}

.ct-div{
  padding-bottom: 20px;
}
ol>li{
  padding-left: 10px;
}
#contract1>*{
  line-height: 23px;
}

.ct-span{
  font-weight: bolder;
  margin-right: 5px;
}
#t>tr>td{
  text-align: left;
}
</style>